import React from 'react';
import { Grid } from '@material-ui/core';
import {
  string, shape, bool, node, oneOfType,
} from 'prop-types';
import ColumnSection from '../ColumnSection';
import variables from '../../styles/variables.module.scss';
import DefaultLink from '../../typeface/DefaultLink';
import HeadlineSmall from '../HeadlineSmall';
import styles from './style.module.scss';

const ActionColumnSection = ({
  headlineSmall,
  headlineLarge,
  stroke,
  title,
  body,
  data,
  backgroundColor,
  textColor,
  headlineLineBreak,
}) => (
  <ColumnSection
    headlineLarge={headlineLarge}
    headlineSmall={headlineSmall}
    stroke={stroke}
    title={title}
    body={body}
    backgroundColor={backgroundColor}
    textColor={textColor}
    headlineLineBreak={headlineLineBreak}
  >
    <Grid item>
      <DefaultLink to="/weare" className={styles.link} style={{ color: textColor }}>
        <p>{data.linkText}</p>
      </DefaultLink>
      <HeadlineSmall color={textColor} style={{ marginTop: '64px' }}>{data.headlineText}</HeadlineSmall>
      <Grid container direction="row">
        <Grid item xs={12} sm style={{ marginTop: '16px' }}>
          <p style={{ color: textColor }}>{data.firstTitle}</p>
          <DefaultLink href={`mailto:${data.firstEmail}`} style={{ color: textColor }}>
            <p>{data.firstEmail}</p>
          </DefaultLink>
        </Grid>
        <Grid item xs={12} sm style={{ marginTop: '16px' }}>
          <p style={{ color: textColor }}>{data.secondTitle}</p>
          <DefaultLink href={`mailto:${data.secondEmail}`} style={{ color: textColor }}>
            <p>{data.secondEmail}</p>
          </DefaultLink>
        </Grid>
      </Grid>
    </Grid>
  </ColumnSection>
);

ActionColumnSection.propTypes = {
  headlineSmall: string,
  headlineLarge: string,
  stroke: string,
  title: oneOfType([
    string,
    node,
  ]),
  body: oneOfType([
    string,
    node,
  ]),
  backgroundColor: string,
  textColor: string,
  data: shape({
    linkText: string,
    headlineText: string,
    firstTitle: string,
    firstEmail: string,
    secondTitle: string,
    secondEmail: string,
  }),
  headlineLineBreak: bool,
};

ActionColumnSection.defaultProps = {
  headlineSmall: null,
  headlineLarge: null,
  stroke: null,
  title: null,
  body: null,
  data: null,
  backgroundColor: variables.tuna,
  textColor: variables.cleanWhite,
  headlineLineBreak: true,
};

export default ActionColumnSection;
